import { MAX_DB_INTEGER } from '../constants';
import { BaseDecoratorOptions } from '../types';

import { ApiPropertyNumber } from './number.decorator';

type PropertyIdParams = {
  each?: boolean;
} & BaseDecoratorOptions<number>;

export function ApiPropertyId(options: PropertyIdParams = {}): PropertyDecorator {
  return ApiPropertyNumber({ ...options, min: 1, max: MAX_DB_INTEGER });
}
